import React from "react";

export function Html({ as = "div", code, ...props }) {
  return React.createElement(as, {
    ...props,
    dangerouslySetInnerHTML: { __html: code },
  });
}
